/**
 * "Crear tu Look" drawer (snippets/look-drawer.liquid).
 *
 * Opens on any `.complete-look-btn` click and slides in from the right.
 *
 * Step 1: each category row shows its product options side by side as selectable tiles;
 * picking one marks it selected (a small underline appears). Clicks are intercepted so
 * the underlying product card doesn't navigate.
 *
 * Step 2 (after "Continuar"): the drawer gets `.is-step-2`; CSS keeps only each row's
 * selected option, revealed as a card with quick-buy. "Volver" returns to step 1.
 *
 * No cart action of its own — quick-buy is handled by the card's own controls.
 */
(function () {
  const BODY_OPEN_CLASS = 'look-drawer-open';
  const STEP2_CLASS = 'is-step-2';

  class LookDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.look-drawer');

      this.onDocClick = this.onDocClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    onDocClick(e) {
      const opener = e.target.closest('.complete-look-btn');
      if (opener) {
        e.preventDefault();
        this.open();
        return;
      }

      const closer = e.target.closest('[data-look-close]');
      if (closer && this.contains(closer)) {
        e.preventDefault();
        this.close();
        return;
      }

      if (e.target.closest('[data-look-continue]') && this.contains(e.target)) {
        this.classList.add(STEP2_CLASS);
        if (this.dialog) this.dialog.scrollTop = 0;
        return;
      }

      if (e.target.closest('[data-look-back]') && this.contains(e.target)) {
        this.classList.remove(STEP2_CLASS);
        return;
      }

      // Step 1: selecting an option must not navigate to the product page.
      if (!this.classList.contains(STEP2_CLASS)) {
        const option = e.target.closest('[data-look-option]');
        if (option && this.contains(option)) {
          e.preventDefault();
          this.selectOption(option);
        }
      }
    }

    onKeydown(e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && this.hasAttribute('open')) {
        this.close();
      }
    }

    open() {
      if (this.hasAttribute('open')) return;
      this.setAttribute('open', '');
      document.body.classList.add(BODY_OPEN_CLASS);
      if (this.dialog) this.dialog.focus();
    }

    close() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      document.body.classList.remove(BODY_OPEN_CLASS);
    }

    selectOption(option) {
      const row = option.closest('[data-look-row]');
      if (!row) return;
      row.querySelectorAll('[data-look-option]').forEach(function (el) {
        el.classList.remove('is-selected');
      });
      option.classList.add('is-selected');
    }
  }

  if (!customElements.get('look-drawer')) {
    customElements.define('look-drawer', LookDrawer);
  }
})();
